var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.77344 4.5L7.1875 2.10938L7.67969 1.61719C7.75 1.54688 7.75 1.42969 7.67969 1.33594L7.16406 0.820312C7.07031 0.75 6.95312 0.75 6.88281 0.820312L4 3.72656L1.09375 0.820312C1.02344 0.75 0.90625 0.75 0.8125 0.820312L0.296875 1.33594C0.226562 1.42969 0.226562 1.54688 0.296875 1.61719L3.20312 4.5L0.296875 7.40625C0.226562 7.47656 0.226562 7.59375 0.296875 7.6875L0.8125 8.20312C0.90625 8.27344 1.02344 8.27344 1.09375 8.20312L4 5.29688L6.39062 7.71094L6.88281 8.20312C6.95312 8.27344 7.07031 8.27344 7.16406 8.20312L7.67969 7.6875C7.75 7.59375 7.75 7.47656 7.67969 7.40625L4.77344 4.5Z",
    fill: "#DC3545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.219f7a55.svg";
export { ForwardRef as ReactComponent };